export default {
  PersonalCenter: '개인정보',
  MemberManage: '팀원관리',
  MemberGroupManage: '그룹관리',
  RightsManage: '권한 관리',
  Channel: '확인',

  // 常用字词
  Confirm: '확인',
  Clear: '삭제',
  NextPage: '다음 페이지',
  PreviousPage: '이전 페이지',
  PleaseSelect: '선택',
  PleaseInput: '입력',
  CreateTime: '등록일',
  NoDataAvailable: '처리중',
  RegionSelection: '지역선택',
  Remarks: '비고',
  ContactInformation: '연락처',
  BatchOperation: '일괄처리',
  BulkApproval: '일괄등록',
  BulkRejection: '일괄기각',
  Share: '공유',
  Export: '추출',
  ExportAll: '전체 추출',
  ExportSelected: '선택 추출',
  Pass: '통과',
  Reject: '반려',
  OperationSuccessful: '처리완료!',
  Attachment: '첨부',
  Download: '다운로드',
  // 一级菜单部分
  WorkBench: '종합현황',
  Project: '프로젝트관리',
  Customer: '고객',
  IntelligenceManage: '정보관리',
  ClueManage: '단서관리',
  CaseManage: '안건 관리',
  SettlementCenter: '정산 센터',
  Tools: '도구',
  SupplierManage: '법률팀관리',
  IntellectualPropertySaaS: '지적재산권 SaaS',

  // 二级菜单部分
  ProjectList: '프로젝트리스트',
  AndunClue: '안둔 단서',
  PendingReview: '심사대기',
  All: '전부',
  CluesForTesting: '단서구매',
  VendorClues: '법률팀 단서',
  AndunCase: '안둔 안건',
  CivilCase: '민사 안건',
  CriminalCase: '형사 안건',
  AdministrativeCase: '행정 안건',
  VendorCase: '법률팀 안건',
  InvoiceManage: '영수증 관리',
  InvoiceList: '영수증 목록',
  CopyrightInfringe: '침해 모니터링',
  OnlineMonitor: '온라인 모니터링',
  OfflineMonitor: '오프라인 모니터링',
  OwnershipSearch: '권한 검색',
  PatentSearch: '특허 검색',

  // 工作台部分
  DataOverview: '데이터 검열',
  AddNewClues: '신규 단서',
  AnnualNewClues: '년도 증가 단서',
  MonthlyNewClues: '월별 증가 단서',
  units: '건',
  AddNewCase: '신규 안건',
  NewCasesInTheYear: '년도 증가 안건',
  MonthlyNewCases: '월별 증가 안건',
  CaseClosed: '종결',
  AccumulatedNumberOfClosed: '누적 종결 수량',
  AccumulatedNumberOfClosedCasesForTheYear: '년도 누적 종결 수량',
  CompensationPayment: '배상금',
  Amount: '금액',
  CumulativeTotalAmount: '누적 총 금액',
  ClueCase: '단서-안건',
  Yuan: '위안',
  TotalCompensationAmount: '배상금 총액',
  AccumulatedNumberOfCases: '누적 안건 수량',
  AccumulatedNumberOfclues: '누적 단서 수량',
  EvidencePendingEvidence: '채증완료 -채증대기',
  CasesWithEvidenceObtained: '채증완료 안건 수량',
  CasesPendingEvidenceCollection: '채증대기 안건 수량',
  OngoingCasesTerminatedCases: '진행중인 안건-종료안건',
  NumberOfOngoingCases: '처리중인 안건 수량',
  NumberOfTerminatedCases: '종료된 안건 수량',
  DataAnalysisOfInfringementMethods: '침권방식 데이터 분석',
  SalesChannelDataAnalysis: '판매경로 데이터분석',
  ClueDataAnalysis: '단서 데이터분석',
  CaseDataAnalysis: '안건데이터 분석',
  DataStatistics: '데이터 총계',
  DistributionOfCluesByRegion: '단서구역 분포',
  DistributionOfLawyerPopulation: '변호인수 분포',
  DistributionOfOngoingCasesByRegion: '활성 사례의 지역 분포',
  AuditTrends: '심의 추세',
  Online: '온라인',
  Offline: '오프라인',
  CustomerData: '고객 데이터',
  DetailedData: '상세 데이터',
  ClueVolume: '단서 수량',
  //  项目列表部分
  Status: '상태',
  ProjectName: '항목 명칭',
  ProjectCycle: '항목 주기',
  // 项目详情
  ProjectStatus: '항목 상태',
  ProjectRemarks: '항목 참고',
  ProjectOverview: '항목 개황',
  IntellectualProperty: '지재권',
  BillOfMaterials: '자료리스트',
  InfringementMap: '침해 지도',
  NumberOfClues: '단서 수량',
  Add: '신 증가 ',
  //   -----------------15：29
  Delete: '제거',
  RightsNumber: '권리번호',
  RightsType: '권리유형',
  TrademarkClassification: '상표분류',
  PatentClassification: '특허분류',
  RightsHolder: '권리인',
  FileName: '문건명',
  rightTitle: '권리명칭',
  statusRights: '권리상태',
  descriptionRights: '권리묘사',

  // 情报管理
  Genplaceholder: '점포명칭/제품명칭/신고인명칭',
  InvestigationArea: '조사구역',
  InvestigationDate: '조사날짜',
  AllocationStatus: '분배상태',
  AssignedTeam: '분배 팀',
  ProductName: '제품명칭',
  AllocationTime: '분배시간',
  StoreName: '점포명칭 ',
  UnitPrice: '제품단가',
  StoreAddress: '점포주소',
  MonthlySalesVolume: '월판매량',
  Reporter: '신고인',
  VerificationStatus: '상태확인',
  VerificationTime: '시간확인',
  // 线索管理
  reviewedClueSearch: '항목/점포명/단서번호/침권주체',
  ChannelReviewedClueSearch: '/점포명/단서번호',
  InfringementArea: '침권구역',
  InvestigationTime: '조사시간',
  InfringementMethod: '침권방식',
  ClueType: '단서유형',
  reportTime: '신고시간 ',
  Test: '데스트',
  Serial: '번호',
  Intelligence: '정보',
  PushTime: '송달시간',
  Vendor: '판매상',
  InfringingLink: '침권URL',
  InvestigationAddress: '조사주소',
  Manufacturer: '생산상',
  ReportTeam: '신고 팀',
  ShopkeepID: '점주번호',
  ReviewStatus: '심사상태',
  AuditTime: '심사시간',
  Approved: '심사통과',
  Rejected: '심사반려',
  ReviewComment: '심사 주문',
  Note: '쪽지',
  BulkExportImages: '일괄추출도면',
  Yes: '예',
  No: '아니요',
  TestPurchase: '데스트구매 했는지 여부',
  ReasonRejection: '반려 원인',
  // 驳回表单
  ReasonError: '반려원인은 공란일수 없습니다',
  ReasonReviewError: '심사원인은 공란일수 없습니다',
  ReasonReview: '심사원인 ',
  notesError: '비고란을 기재해주세요',
  max512Error: '512개 글자를 넘을수없습니다',
  max32Error: '32개 글자를 넘을수없습니다',
  max16Error: '16개 글자를 넘을수 없습니다.',
  NameCannot: '이름은 꼭 기재해야합니다',

  // 线索详情
  BasicInformation: '기본정보',
  InfringingProduct: '침권제품',
  SalesVolume: '판매량',
  SalesChannel: '판매채널',
  PlatformName: '플랫폼 명칭',
  BulkOperation: '최소수량',
  StoreLink: '점포URL',
  ProductLink: '제품URL',
  NoVendor: '잠시 판매량이 없습니다',
  NoManufacturer: '잠시 생산상이 없습니다',
  TestShop: '테스트 구매',
  TestShopImage: '테스트구매도면',
  NoTestShop: '잠시 테스트구매 정보가 없습니다.',
  sendSamples: '샘플발송여부',
  courierCompany: '운송회사',
  trackingNumber: '운송장번호',
  senderName: '발송인 성명',
  sender: '발송인 ',
  senderRegion: '발송인 지역',
  senderFullAddress: '발송인 상세주소',

  // 当事人信息
  EntityNature: '사업체 종류',
  EntityName: '사업체 명칭',
  EntityType: '사업체 유형',
  EntityTag: '사업주체 상표',
  Individual: '개인',
  EnterpriseCompany: '기업',
  proprietorship: '개인사업자',
  BusinessEntity: '운영주체',
  IDNumber: '신분증번호',
  NatureBusiness: '경영종류',
  EntityRegion: '사업지역',
  OpposingPartyDetail: '상대 당사자 상세',
  BillingEntity: '영수증발급 주체',
  POSEntity: 'POS기 주체',
  CreditCode: '신용코드',
  LegalRepresentative: '법정대표인',
  Operator: '경영자',
  BusinessRegistrationAddress: '공상등록주소',
  determinationImage: '인정 근거 이미지',
  ManufacturerName: '생산상 명칭',
  determinationDescription: '인정 근거 묘사',
  UpdateTime: '갱신시간',
  BusinessChange: '공상 변경',
  BusinessAnomaly: '경영이상',
  DishonestyInformation: '불신용 정보',
  AdministrativePenalty: '불신용 정보',
  JudicialVerdict: '판결문서',
  CourtAnnouncement: '법정공고',
  CourtHearingNotice: '개정공고',
  Debtor: '피집행인',
  // 案件列表
  CaseSearchInput: '안건번호/대상당사자/단서번호/점포명칭/판매상/생산상',
  CaseSupplierCaseSearchInput: '안건번호/단서번호',
  CaseArea: '안건지역',
  CaseType: '안건유형',
  EvidenceStatus: '취증상태',
  Hasmanufacturer: '생산상유뮤',
  SelectTime: '시간을 선택하세요',
  CaseProgress: '안건진도',
  CaseCode: '안건번호 ',
  OpposingParty: '상대당사자',
  CaseStatus: '안건상태',
  TerminationReason: '종료원인',

  // 案件详情
  CaseTerminated: '안건종료',
  Termination: '종료 ',
  Restoration: '회복',
  ReviewTerminationApplication: '심사종료신청',
  RelatedCases: '관련안건',
  Memo: '비망',
  HandlingTeam: '처리 팀',
  CaseNote: '안건 참조',
  ClueDetail: '단서 상세 상황',
  CaseEvidence: '안건증거',
  CaseProcess: '안건절차',
  CaseLog: '안건일지',
  CaseMemo: '안건비망',
  ClueNumber: '단서번호',
  Evidence: '증거',
  EvidenceDetail: '증거 상세상황',
  EvidenceType: '증거유형',
  NotarialEvidence: '공증서번호/증거번호',
  EvidenceCollectionTime: '취증시간',
  SignatureNotarizationTime: '낙관/고증시간',
  NotarialCertificateAttachment: '공증서 첨부서류',
  NoMemo: '잠시 비망정보가 없습니다.',
  LetterRecordLawyer: '내용증명발송기록(변호사내용증명)',
  LetterRecordComplaint: '내용증명발송기록(온라인신고)',
  TrackingNumber: '택배번호',
  OnlineDocument: '온라인문서',
  DateSendLetter: '내용증명발송시간',
  LetterContent: '내용증명발송방식',
  MethodSendingLetter: '发函方式',
  receipt: '읽은 접수증 받았는지 여부',
  LogisticsInformation: '물류정보',
  ComplaintTime: '신고시간',
  ComplaintWebsite: '신고인터넷주소',
  ComplaintPlatform: '신고플랫폼',
  ComplaintContent: '신고내용',
  ApplicationMaterial: '작성자료',
  MaterialDelivery: '자료송부',
  ReasonCase: '안건개요',
  InfringementRights: '침권권리',
  Attorneyatlaw: '대리변호사',
  SubjectMatterLitigation: '소송표적',
  reasonableExpenses: '합리적지출',
  JurisdictionalCourt: '관할법원',
  AffixingPersonalSeal: '사용인감낙인',
  NoMoment: '잠시 관련정보가 없습니다',
  Sender: '발송인',
  Recipient: '수취인',
  MailingTime: '발송시간',
  Mailing: '우편물발송',
  SelfPickUp: '직접받음',
  MailMethod: '우편방식',
  CourierCompany: '택배회사',
  ContentsPackage: '택배내용',
  Received: '수취인의',
  TrackShipment: '물류확인',
  SubmitDocument: '자료제출',
  litigationCoordination: '소송전 합동조사',
  Acceptance: '수리',
  SubmissionDate: '자료제출날짜',
  SubmissionMethod: '제출방식',
  receivCourt: '접수법원',
  testingPeriod: '합동조사시간',
  summons: '소환장',
  preservation: '보전',
  publicNotice: '공고송달',
  exchangeOfEvidence: '증거교환',
  jurisdictionalObjection: '관할이전',
  courtHearTime: '개정시간',
  courtJurisdiction: '개정법원',
  presidingJudge: '재판장',
  assistant: '주무',
  subpoenaAttachment: '소환장 첨부서류',
  typesOfInterimMeasures: '보전유형',
  respondent: '피신청인',
  amountInterimMeasure: '보전금액',
  interimMeasureDocuments: '보전자료',
  formNotice: '공고형식',
  noticePeriod: '공고기간',
  noticeExpenses: '공고비용',
  noticeMaterials: '공고자료',
  evidenceExchangeDeadline: '증거교환시간',
  location: '지점',
  participants: '참여인원',
  opposingEvidence: '상대방증거',
  PlaintiffAttorney: '원고대리인',
  DefendantLegalRepresentative: '피고대리인',
  opposingPartyPresent: '상대당사자 법정도착여부',
  trialProceeding: '법정심문내용',
  courtDocuments: '법정심문자료',
  JudgmentDate: '판결일자',
  dateReceipt: '수령서명일자',
  judgmentAmount: '판결금액',
  opposingParty: '상대방부담 소송비금액',
  excerptJudgment: '판결발췌',
  judgment: '판결서',
  judgmentResult: '판결결과',
  paymentRecord: '입금기록',
  receivableAmount: '받을금액',
  actualAmountReceived: '실수령금액',
  closureDate: '안건종결시간',

  // —————————————————————————— 15:57
  caseClosureMethod: '안건종결방식',
  accountsReceivable: '받을금액',
  amountCollected: '실수령금액',
  caseResolutionDetail: '안건종결내용',
  litigationAnalysis: '소송분석',
  confirmationStatus: '확인상태',
  pendingConfirmation: '기 확인',
  confirmed: '확인중',
  closingDocument: '안건종결 문서',
  paymentDate: '지불 시간',
  compensationAmount: '배상금액',
  litigationRefund: '소송환급비',
  payingEntity: '지불 주체',
  recipientPayment: '수령인',
  receiptDate: '수령시간',
  mediationParty: '중재대상',
  mediationContent: '중제내용',
  mediationAmount: '중재금액',
  auditResult: '심사결과',
  auditRemarks: '심사비고',
  mediationOutcome: '중재결과',
  mediationAgreement: '중재협의',
  mediationReview: '중재심의',
  executionCaseNumber: '집행안건번호',
  NoExecution: '잠시 집행결과가 없습니다.',
  filingFee: '접수비용',
  terminationExecutionDate: '집행종결일자',
  reasonTerminationExecution: '집행종결이유',
  reasonPayment: '미납사유',
  executionAmount: '집행금액',
  appendixEnforcementOutcome: '집행결과첨부서류',
  appendixEnforcementApplication: '집행신청 첨부서류',
  NoExecutionRequired: '집행필요없음',
  partyWithdrawLawsuit: '고소취하대상',
  reasonWithdrawalLawsuit: '고소취하이유',
  attachmentSubpoena: '소환장 첨부서류',
  beenApproved: '소송취하심사를 통과하셨습니까?',
  partySettlement: '합의대상',
  settlementAmount: '합의비고',
  releaseRemarks: '합의금액',
  settlementOutcome: '합의결과',
  settlementAgreement: '합의협의',
  settlementReview: '합의심사',
  beenReviewed: '심사를 하셨나요?',
  thisSettlementProposal: '이번 합의의 방안은?',
  thisSettlementMediation: '이번 조정의 방안은?',
  receivingCourt: '접수법원',
  dateAcceptance: '접수일자',
  deadlineSubmittingEvidence: '증거제출기한',
  to: '~까지',
  noticeAcceptance: '접수통지',
  paymentReceipt: '납부영수증',
  attendingLawyer: '출정변호사',
  contractedSupplier: '도급 법률팀',
  investigationCaseNumber: '연합조사번호',
  jointInvestigationPeriod: '예상연합조사주기',
  		'case.caseDetail.381149-0': '자격 증명을 종료하려면 다음과 같이 하십시오.',
  'case.caseDetail.381149-1': '자격 증명 보기',
  'case.caseDetail.381149-2': '설명을 종료하려면 다음과 같이 하십시오.',
  'case.caseDetail.381149-3': '종료 시간:',
  'case.caseDetail.381149-4': '종료 상태:',
  'case.caseDetail.381149-5': '종료됨',
  'case.caseDetail.381149-6': '첨부 파일',
  // 成员管理
  AddNewMember: '신 추가 인원',
  moreOperations: '더많은 작업',
  JoiningTime: '가입시간',
  AreaJurisdiction: '소속지역',
  DownloadQRCode: 'QR code다운로드',
  DisableConfirmation: '확인금지',
  DisableAccount: '관리자의 사용금지 아이디를 확인하셨나요?',
  EnableConfirmation: '사용확인',
  EnableAccount: '관리자의 사용확인 아이디를 확인하셨나요?',
  MemberDetail: '관리자상세',
  BusinessPermissions: '업무권한',
  CopyLink: 'URL복사',
  Role: '역할',
  AccountStatus: '아이디상태',
  AccountInformation: '아이디정보',
  WeChatID: '위쳇번호',
  Unbind: '해결',
  SetPassword: '비밀번호설치',
  ModifyAccount: '아이디번호 수정',
  editOnly: '귀하의 아이디는 한번의 수정이가능합니다. 아래 정보를 기재하세요',
  OriginalAccount: '이전 아이디',
  NewAccount: '새 아이디',
  Address: '주소',
  IsAdministrator: '관리자인지 여부',
  ViewDataPermission: '업무 관리 권한',
  RegionManagement: '지역 관리 권한',
  Account: '아이디',
  AccountCannot: '아이디는 공란일수없습니다',
  password: '비밀번호 ',
  PasswordCannot: '비밀번호는 공란일수없습니다',
  validEmail: '정확한 이메일주소를 입력하세요',
  region: '지역',
  SelectAdministrator: '관리자인지 여부 선택',
  Save: '저장',
  ReasonDisable: '사용금지 이유',
  ReasonErrorJinYong: '사용금지 이유를 입력하세요',
  // 开票管理
  InvoiceSearch: '영수증발급번호/항목명칭/발급회사명칭',
  InvoiceDate: '영수증발급시간',
  ApplicationDate: '신청시간',
  Applicant: '신청인',
  InvoiceNumber: '영수증발급신청번호',
  InvoiceIssuingUnitName: '영수증발금회사명칭',
  InvoiceAmount: '영수증금액',
  InvoiceType: '영수증유형',
  InvoiceStatus: '영수증발급상태',

  // 开票详情
  InvoiceInformation: '영수증정보',
  CustomerName: '고객명칭',
  TaxpayerIdentificationNumber: '납세인식별번호',
  PhoneNumber: '전화',
  IncomeType: '수입유형',
  AffiliatedCompany: '소속회사',
  AssociatedContract: '관련계약서',
  InvoiceContent: '영수증발급내용',
  Nature: '성질(형태?)',
  InvoiceRemark: '영수증 비고',
  SettlementStatementInformation: '정산서 정보',
  ContractDetail: '계약 상세',
  ContractName: '계약명칭',
  ContractNumber: '계약번호',
  Creator: '창시자',
  SigningDate: '계약일자',
  ContractValidityPeriod: '계약유효기간',
  ContractType: '계약종류',
  SettlementNumber: '정산서번호',
  SettlementType: '정산서유형',
  NumberOfCases: '안건수량',
  Payee: '수취인',
  RiskAgencyFeeIncludingCosts: '위험부담금(원가포함)',
  CustomerAuthorizationFee: '고객 수권비',
  SettlementAmount: '정산금액',
  Total: '합계',
  ProjectAffiliation: '소속안건',
  TotalSettlementAmount: '결산합계금액(을측 지불)',
  CaseInformation: '안건정보',
  CaseNumberAnHao: '안건번호',
  LitigationRefund: '소송환급금',

  // 工具
  AddMonitoringTask: '추가 모니터링작업',
  ViewMonitoringTask: '모니터링작업 보기',
  TaskName: '작업명칭',
  MonitoringKeyword: '모니터링 키워드',
  OnlineSearchInput: '작업명칭/모키터링 키워드',
  view: '보기',
  Start: '작동',
  StartStatus: '상태작동',
  startTask: '이 작업을 시작할까요?',
  monitoringPlatform: '모니터링 플랫폼',
  searchKeyword: '검색 키워드',
  sortMethod: '배열방식',
  defaultSort: '기본정렬',
  highToLowPrice: '가격고저',
  requiredKeyword: '필수키워드',
  OnlyTheDataContain:
    '해당 키워드입력 후 상품제목에 해당하는 키워드중 하나라도 포함된 데이터가 획득됩니다.',
  separatedByCommas: '여러 키워드는 쉼표로 구분합니다',
  automatically:
    '해당 키워드를 입력후 상품제목에 해당 키워드중 하나라고 포함되어 있으면 자동으로 제외됩니다',
  negativeExpression: '단어설정여부',
  MaximumNumber: '단일 플랫폼 최대 데이터 개수',
  entries: '100의정수,최소 100개 최대 5000개를 입력하세요',
  enterNumbe: '숫자를 입력하세요',
  enterInteger: '정수만 입력가능합니다.',
  greaterThan100: '100보다 큰 정수를 입력하세요',
  cannotExceed5000: '최대 개수는 5000을 초과할수없습니다',
  cannotBeEmpty: '임무명칭은 공란일수 없습니다.',
  leastOnePlatform: '최소 하나의 플랫폼을 선택하세요',
  searchKeywordCannot: '검색 키워드는 공란일수 없습니다',
  serialNumber: '순서',
  PlatformType: '플랫폼유형(모니터링상태)',
  monitorProduct: '모니터링제품',
  monitorStore: '모니터링 점포',
  MonitorStartTime: '모니터링 시작 시간',
  negation: '글자여부',
  summary: '일괄',
  product: '제품URL',
  platformDataStatistic: '플랫폼데이터총계',
  priceRangeStatistic: '가격구간총계',
  Top10SellingStore: '판매점포Top10',
  Top10SellingProduct: '판매상품 Top10',
  numberProduct: '상품수',
  price: '가격',
  TaobaoNumber: '타오바오판매브랜드상품수',
  TmallNumber: '티몰판매브랜드상품수',
  JDComNumber: '징동판매브랜드상품수',
  AlibabaNumber: '아리바바판매브랜드상품수',
  PinduoduoNumber: '핀둬둬판매브랜드상품수',
  SelectCategory: '선택분류',
  MonitorScope: '모니커링범위',
  MonitorCategorie: '모니터링분류',
  CumulativeMonitorCount: '누적 모니터링 수량',
  MonitoringStatu: '모니터링상태',
  MonitoringRetrievalTime: '캡처시간모니터링',
  PleaseInputkeyword: '키워드를 입력하세요',
  image: '이미지',
  Type: '유형',
  QuantityGoods: '제품수량',
  MinimumSalesVolume: '최저판매량',
  MaximumSalesVolume: '최고판매량',
  SalesRange: '판매구간',
  shipment: '발송지',
  SellingPrice: '판매가격',
  Day30SalesVolume: '판매가격',
  oldOnlineMonitor: '온라인 모니터링（오래된）',

  // ___________________   16:24

  TaskHall: '임무 Hall',
  DoingTask: '처리중인 이무',
  Team: '로펌팀',
  Financ: '재무',
  Riskloan: '벤처캐피털',
  ClueTask: '단서발견임무',
  PublicTask: '공공임무',
  DesignateTask: '배속임무',
  CaseTask: '안건타격임무',
  PublicCase: '공공안건',
  DesignateCase: '배속안건',
  Clue: '단서',
  Case: '안건',
  MyTask: '나의임무',
  AllTask: '전체임무',
  MyResult: '나의결과',
  AllResult: '전체결과',
  MyCase: '나의안건',
  Inprogress: '진행중',
  Ended: '종결',
  AllCase: '전부안건',
  AwaitAllocationCase: '분배대기안건',
  MyTransactionCase: '나의 판매(처리?)안건',
  Processing: '판매(처리?)중',
  Transacted: '판매(처리?)완료',
  AllTransactionCase: '전체판매(처리?)안건',
  TeamManagement: '인원관리',
  JobPermissions: '직무권한',
  MyCenter: '퍼스널센터',
  ResetPwd: '비밀번호수정',
  Exit: '나가기',
  Name: '성명',
  Sex: '성별',
  Duties: '임무',
  Mail: '이메일',
  Mobile: '휴대전화',
  Operating: '조작',
  AddEmployee: '신규인원',
  editIcon: '편집',
  prohibitIcon: '사용금지',
  resetIcon: '비밀번호재설정',
  enableIcon: '가동',
  'name/account/tel': '姓名/账号/手机',
  tortSubjectProperty: {
    P: '신분증번호',
    E: '법정대표인',
    I: '경영자'
  },
  isEnable: {
    Y: '가동',
    N: '사용금지'
  },
  cancel: '취소',
  reset: '재설정',
  sure: '확인',
  forbidUserModal: '고객사용정지를 확정합니까?',
  resetModal: '재설정을 확정합니까?',
  enableModal: '고객 가동을 확인합니까?',
  BatchEnableList: {
    Y: '일괄가동',
    N: '일괄중지'
  },
  role: {
    All: '전부'
  },
  lawyerList: {
    lawyer: '변호사',
    'not-lawyer': '비 변호사'
  },
  'identity-information': '신분증번호',
  certificateType: {
    IC: '신분증',
    PP: '여권'
  },
  'ID-type': '여권종류',
  tort_type: {
    E_EC: '전자상거래플랫폼',
    S_ST: '실제점포',
    S_FA: '공장',
    S_OT: '기타',
    E_WL: '홈페이지URL'
  },
  ec_channel: {
    TT: '타오바오',
    TS: '타오터',
    TM: '티몰',
    AL: '아리바바',
    JD: '징동',
    SN: '수닝',
    YH: '1호점',
    PD: '핀둬둬',
    OT: '기타',
    DY: '틱톡'
  },

  // 项目状态
  projectState: {
    R: '진행중',
    P: '잠시정지',
    A: '분류보존',
    E: '기한경과'
  },
  // 分配状态
  allocationState: {
    P: '분배대기',
    E: '분배완료'
  },
  // 核实状态
  verifyState: {
    P: '검증대기',
    E: '검증완료',
    R: '검증무효'
  },
  CaseState: {
    '1': '처리완료안건',
    '0': '미처리안건'
  },
  ClueReviewState: {
    C: '고객확인중',
    CP: '고객심사완료',
    CD: '고객심사거절'
  },
  // 线索驳回
  ClueReject: {
    A1: '가맹점입니다',
    A2: '기소완료',
    A3: '자료불완정',
    A4: '정품'
  },
  // 线索通过
  ClueAgree: {
    A1: '가맹점이 아닙니다',
    A2: '모조품인지 확인'
  },
  // 民事案件进度
  CivilCaseProgressState: {
    PN: '방안',
    SR: '내용증명발송',
    RR: '입안',
    PL: '법원 개정전',
    CG: '법정심의',
    JT: '판결',
    EC: '분류보존',
    TN: '종결',
    AC: '입금',
    EN: '집행',
    RE: '합의',
    ME: '조정',
    WD: '소 취하'
  },
  // 刑事案件进度
  CivilCaseProgressState1: {
    CRAP: '형사신청',
    RR: '입안',
    INVE: '정찰수사',
    REPR: '심사기소',
    JT_BB: '판결',
    EC_EC: '분류보존'
  },
  // 行政案件进度
  CivilCaseProgressState2: {
    ADAP: '행정신청',
    RR: '입안',
    INVE: '정찰수사',
    EC_EC: '분류보존'
  },
  // 案件类型
  CaseTypeState: {
    online: '온라인',
    offline: '오프라인',
    1: '오프라인',
    2: '온라인'
  },
  // 取证状态
  EvidenceState: {
    P: '채증대기',
    W: '확인하려면',
    A: '인증'
  },
  // 案件状态
  CaseStates: {
    HH: '진행중',
    TN: '종료',
    ED: '종결'
  },
  // 账号状态
  AccountState: {
    false: '사용금지',
    true: '가동'
  },
  // 性别
  SexState: {
    F: '여성',
    M: '남성'
  },
  // 到款状态
  paymentRecordState: {
    P: '확인중',
    E: '기 확인'
  },
  InvoiceState: {
    P: '청구 중',
    E: '청구 승인됨',
    R: '청구 거부됨'
  },

  ReviewState: {
    '10': '심사 중',
    '40': '거부 및 종료',
    '99': '심사 승인됨'
  },
  onlinePlatformState: {
    '1': '타오바오',
    '2': '티몰',
    '3': '징동',
    '5': '알리바바',
    '6': '핀두오두오'
  },
  IpState: {
    正常: '정상',
    暂缓: '유보',
    终止: '종료',
    未授权: '미승인'
  },
  materialsListState: {
    CM: '프로젝트 협업 자료',
    EM: '위탁 자료',
    LD: '소송 문서 템플릿',
    MM: '본문 자료',
    NE: '알려진 증거',
    OO: '기타',
    PO: '프로젝트 원본',
    RP: '본문 자료',
    WD: '선례/관련 사례',
    WM: '소유권 자료'
  },
  CaseProgressState: {
    LL: '발송',
    PN_BB: '소송 계획',
    PN_JC: '서류 발송',
    RR: '사건 접수',
    RR_BB: '서류 제출',
    RR_AD: '사건 수리',
    PL: '심판 전',
    PL_BB: '소환장 송달',
    PL_EE: '증거 교환',
    PL_AS: '공고 송달',
    PL_OP: '관할권 이의',
    PL_PR: '가처분',
    CG_CG: '법정 심리',
    JT_BB: '판결',
    JT_AE: '항소',
    JT_RP: '소송 응답',
    CO_CO: '집행',
    CO_SE: '서류 발송',
    CO_RE: '집행 결과',
    ST: '입금',
    ST_DL: '입금 기록',
    EC_EC: '사건 보관',
    RE_AP: '화해',
    RE_AU: '화해 결과',
    ME_AP: '조정',
    ME_AU: '조정 결과',
    WD_AP: '소송 취하',
    CU_RE: '환불',
    RR_LA: '소송 전 조정',
    RR_JG: '조정 결과',
    WD_AP_RE: '화해 후 취하',
    WD_AP_ME: '조정 후 취하',
    CO_FI: '집행 접수',
    CRAP: '형사 신청',
    MAAP: '서류 신청',
    INVE: '수사 활동',
    REPR: '심찰 및 기소',
    ADAP: '행정 신청',
    RESU: '결과',
    SUAI: '보완 수사',
    INDI: '기소 결과',
    CC_SI: '형사 항소심 판결',
    TR_ME: '제3자 조정',
    PI: '사전 조사',
    CF: '사건 접수 단계',
    AT: '조치 단계',
    PP: '공소 단계',
    JG: '판결 단계',
    PU: '처벌 단계'
  },
  // 材料类型
  AttachmentState: {
    PA: '위임장',
    IT: '고소장'
  }
}



// WEBPACK FOOTER //
// ./src/locale/lang/ko-KR.js